
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { FilterMatchMode } from 'primereact/api';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { toast } from 'react-toastify';
import { IScorecardGroupAssign } from '../../../utils/types';
import './edsExceptionGroupAssignment.scss'
import {
    useGetScoreCardOverrideTypesQuery,
    useGetScoreCardsQuery
} from '../../../features/edsDashboard/edsExceptionScorecardAssignment/edsExceptionScorecardAssignmentSlice';
import { DateTemplate } from '../../../components/dateTemplate/DateTemplate';
import { useDeleteScoreCardAssignOverridesGroupMutation, useGetScorecardAssignOverridesQuery, useCreateScorecardGroupAssignMutation } from './edsExceptionGroupAssignmentSlice'

import { useGetScorecardAgentsQuery } from '../../../components/scoreCardFilter/scoreCardFilterSlice'

interface groupAssignment {
    scoreCardName: string,
    inputYear: number
    inputMonth: number,
    loggedEmpNum: string,
    scorecardVersionId: number
    scorecardId: number
}
type EmployeeTL = [
    {
        name: string;
        id: string;
    }
];
// eslint-disable-next-line max-statements
export const EdsExceptionGroupAssignment = (props: groupAssignment) => {
    const [CreateScoreCardAssign] = useCreateScorecardGroupAssignMutation();
    const today = new Date();
    const month = today.getMonth();
    const year = today.getFullYear();
    const [agentIds, setAgentIds] = useState<any>([]);
    const [selectedAgnet, setSelectedAgent] = useState<any>([]);
    const [selectedAgentDelete, setSelectedAgentDelete] = useState<any>([]);
    const curMaxDate = new Date(year, month + 1, 0);
    const curMinDate = new Date(year, month - 8, 1);
    const [newStartDate, setNewStartDate] = useState(new Date(year, month, 1));
    const [expirationDate, setExpirationDate] = useState(new Date(year, month + 1, 0));
    const [newScoreCard, setNewScoreCard] = useState<any>([]);
    const [assignEmployees, setAssignEmployees] = useState<any>([]);
    const [supervisorNumber, setSupervisorNumber] = useState<string>();
    const [scoreCardOverride, setScoreCardOverride] = useState<any>([]);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [statusData, setStatusData] = useState<any>([]);
    const { data: scoreCardsData } = useGetScoreCardsQuery({});
    const { data: scoreCardOverrideTypes } = useGetScoreCardOverrideTypesQuery({});
    const [listOfTls, setListOfTls] = useState<EmployeeTL>([{ name: '', id: '' }]);
    const [initAssignEmployees, setInitAssignEmployees] = useState<any>([])
    const [assignOverridesm, setAssignOverrides] = useState<any>([])
    const [openDialog, setOpenDialog] = useState<boolean>(false);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const [DeleteScoreCardAssignOverridesException] = useDeleteScoreCardAssignOverridesGroupMutation();

    const { data: scorecardSupervisorsData } = useGetScorecardAgentsQuery(
        {
            year: props.inputYear,
            month: props.inputMonth,
            scorecardVersionId: props.scorecardVersionId,
            scorecardRoleId: 2

        },
        { skip: !props.inputYear || !props.inputMonth || !props.scorecardVersionId }
    );

    const { data: scorecardAssignEmployees } = useGetScorecardAgentsQuery(
        {
            year: props.inputYear,
            month: props.inputMonth,
            scorecardVersionId: props.scorecardVersionId,
        },
        { skip: !props.inputYear || !props.inputMonth || !props.scorecardVersionId }
    );

    const { data: scorecardAssignOverrides } = useGetScorecardAssignOverridesQuery(
        {
            scorecardId: props.scorecardId,
        },
        { skip: !props.scorecardVersionId }
    )

    const dialogFunMap = {
        dialogBox: setOpenDialog,
    };

    const diloagHide = () => {
        dialogFunMap.dialogBox(false);
    };

    useEffect(() => {
        setAssignEmployees(scorecardAssignEmployees?.data?.length > 0 ? scorecardAssignEmployees.data : [])
        setInitAssignEmployees(scorecardAssignEmployees?.data?.length > 0 ? scorecardAssignEmployees.data : [])
    }, [scorecardAssignEmployees]);

    useEffect(() => {
        setAssignOverrides(scorecardAssignOverrides?.data?.length > 0 ? scorecardAssignOverrides.data : [])
    }, [scorecardAssignOverrides]);

    useEffect(() => {
        if (scoreCardsData?.data.length > 0) {
            setNewScoreCard(scoreCardsData?.data);
        }
    }, [scoreCardsData]);
    useEffect(() => {
        if (scoreCardOverrideTypes?.data.length > 0) {
            setScoreCardOverride(scoreCardOverrideTypes?.data);
        }
    }, [scoreCardOverrideTypes]);
    useEffect(() => {
        if (scorecardSupervisorsData?.data?.length > 0) {
            const arrayOfUsers: EmployeeTL = scorecardSupervisorsData?.data?.map((item: any) => ({
                name: item?.agent_name.concat(' (', item?.agent_number, ')'),
                id: item?.agent_number,
            }))
            const allLead = {
                name: 'ALL',
                id: 'ALL'
            }
            arrayOfUsers.unshift(allLead)
            setListOfTls(
                arrayOfUsers
            );
            setSupervisorNumber(allLead.id);
        }
    }, [scorecardSupervisorsData]);

    const createScorecardAssign = (startassigndate: any) => {
        CreateScoreCardAssign(startassigndate)
            .unwrap(setSelectedAgent([]))
            .then((response: any) => {
                const idGroups = response.data.split("~");
                const data: any = []
                idGroups.forEach((group: string) => {
                    const obj: any = {}
                    const [id, status] = group.split(":");
                    if (status === 'success-Inserted') {
                        obj.status = 'Inserted';
                        obj.employeeId = id
                    } else if (status === 'error-Already Exists') {
                        obj.status = 'Already Exists';
                        obj.employeeId = id
                    }    
                    data.push(obj)
                });
                setStatusData(data);
                setOpenDialog(true)

            }).catch((error: any) => {
                if (error) console.log(error);
                toast.error(error.message);
            })
    };

    const submitProjectAssignOverrideGroup = () => {
        if (
            props.scoreCardName === ''
        ) {
            toast.error('Select a Valid Associate from Associate Lookup. ');
            return;
        }
        if (selectedAgnet.length > 10) {
            toast.error('You can only move 10 associates at a time');
            return;
        }
        if(newStartDate.getMonth() !== expirationDate.getMonth() || newStartDate.getFullYear() !== expirationDate.getFullYear()){
            toast.error('Start and Expiration Dates should be within the same Month-Year.');
            return;
        }
        if((newStartDate.getMonth()+1 !== props.inputMonth && expirationDate.getMonth()+1 !== props.inputMonth) || newStartDate.getFullYear() !== props.inputYear && expirationDate.getFullYear() !== props.inputYear){
            toast.error('Start and Expiration Dates should be within the same Month-Year.');
            return;
        }
        const agentsArray: string[] = [];
        selectedAgnet.forEach((element: any) => {
            const agentNumberScorecardRoleId = element.agent_number.concat(":", element.scorecard_role_id)
            agentsArray.push(agentNumberScorecardRoleId);
        });
        const startassigndate: IScorecardGroupAssign = {
            employeenumber: agentsArray,
            projectstartdate: newStartDate.toDateString(),
            projectenddate: expirationDate.toDateString(),
            createby: props.loggedEmpNum,
            scorecardid: newScoreCard,
            // scorecardroleid: 2,
            scorecardassignoverridetypeid: scoreCardOverride,
            originalscorecardid: props.scorecardId,
            status: true,
        };
        if (isValidScorecardAssign(startassigndate)) {
            createScorecardAssign(startassigndate);
        } else {
            toast.error('Invalid scorecardAssign data. Please check the data before sending. ');
        }
    }

    const isValidScorecardAssign = (data: IScorecardGroupAssign): boolean => {
        if (
            !(data.employeenumber.length > 0) ||
            typeof data.scorecardassignoverridetypeid !== 'number' ||
            typeof data.createby !== 'string' ||
            // typeof data.scorecardroleid !== 'number' ||
            typeof data.scorecardid !== 'number' ||
            !(data.projectstartdate) ||
            !(data.projectenddate) ||
            typeof data.status !== 'boolean'
        ) {
            return false;
        }
        return true;
    };

    const NewStartDateOnChange = (e: any) => {
        setNewStartDate(e.value);
    };


    const DeleteScorecardException = () => {
        const sCardAssignOverrideIds: any[] = [];
        selectedAgentDelete.forEach((e: any) => {
            sCardAssignOverrideIds.push(e.scorecard_assign_override_id);
        });
        if (sCardAssignOverrideIds.length > 0) {
            DeleteScoreCardAssignOverrides(sCardAssignOverrideIds);
            setSelectedAgentDelete([]);
        } else {
            toast.error('Invalid Scorecard override, please select atleast one scorecard');
        }

    };
    const DeleteScoreCardAssignOverrides = (sCardAssignOverrideIds: any) => {
        DeleteScoreCardAssignOverridesException(sCardAssignOverrideIds)
            .unwrap()
            .then((response: any) => {
                if (response.status) {
                    toast.success('Deleted Successfully');
                }
            }).catch((error: any) => {
                if (error) console.log(error);
                toast.error('Error while deleting');
            })
    };
    const SupervisorOnChange = (e: any) => {
        setSupervisorNumber(e.value);
        if (e.value !== 'ALL') {
            const data = initAssignEmployees.filter((employee: any) => {
                return employee.supervisor_number === e.value
            })
            setAssignEmployees(data)
        } else {
            setAssignEmployees(scorecardAssignEmployees?.data?.length > 0 ? scorecardAssignEmployees.data : [])
        }


    };

    const ExpirationDateOnChange = (e: any) => {
        setExpirationDate(e.value);
    };

    const onSelectionChange = (event: any) => {
        setSelectedAgent(event.value);
        const disputeId = event.value.map((x: any) => x.agent_number);
        setAgentIds(disputeId);
        console.log(agentIds)
    };


    const onSelectionChangeDelete = (event: any) => {
        setSelectedAgentDelete(event.value);
        const disputeId = event.value.map((x: any) => x.oracleId);
        setAgentIds(disputeId);
    };



    const onGlobalFilterChange = (e: any) => {
        const value = e.target.value;
        const afilters = { ...filters };
        afilters.global.value = value;
        setFilters(afilters);
        setGlobalFilterValue(value);
    };

    const handleClickOk = () => {
        diloagHide();
    };

    
    const textColorCondition = (key: string) => {
        let textColor  = ''
        if(key === 'Already Exists'){
            textColor = '#E23636'
        } else {
            textColor = '#2AA154'
        }
        return <span style={{ color: textColor }}>{key}</span>;
      
    }

    const createFooterTemplate = (
        <div className='row'>

            <div className="col-md-4 flex justify-center">
                <Button
                    className="btn-primary"
                    onClick={handleClickOk}
                    label={"Ok"}
                />
            </div>
        </div>
    );

    const renderOverRideHeader = () => {
        return (
            <div className="flex justify-content-between exportexcel">
                <span className="p-input-icon-left">
                    {/* <i className="pi pi-search" /> */}
                    <h5>All Scorecard Overrides</h5>
                </span>
                <span className="p-input-icon-left borderRadius10 mr-2 me-2 float-end">
                    <i className="pi pi-search" />
                    <InputText
                        className=""
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Search"
                    />
                </span>
            </div>
        );
    };
    const overRideHeader = renderOverRideHeader();
    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <div className="card border-0">
                        <div className="card-body border-0">
                            <div className="row mt-2">
                                <div className="col-md-3">
                                    <h6
                                        style={{
                                            fontWeight: '600',
                                            fontSize: '16px',
                                        }}
                                    >
                                        New Start Date
                                    </h6>
                                    <Calendar
                                        id="basic"
                                        value={newStartDate}
                                        onChange={NewStartDateOnChange}
                                        showIcon
                                        className="custom-calendar mb-4"
                                        minDate={curMinDate}
                                        maxDate={curMaxDate}
                                        dateFormat="dd-M-yy"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <h6
                                        style={{
                                            fontWeight: '600',
                                            fontSize: '16px',
                                        }}
                                    >
                                        End Date
                                    </h6>

                                    <Calendar
                                        id="basic"
                                        value={expirationDate}
                                        onChange={ExpirationDateOnChange}
                                        showIcon
                                        className="custom-calendar mb-4"
                                        minDate={newStartDate}
                                        maxDate={curMaxDate}
                                        dateFormat="dd-M-yy"
                                    />
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-md-3">
                                    <h6
                                        style={{
                                            fontWeight: '600',
                                            fontSize: '16px',
                                        }}
                                    >
                                        Current Scorecard
                                    </h6>
                                    <InputText
                                        name="currentScoreCard"
                                        value={props.scoreCardName}
                                        disabled

                                        className="borderRadius w-100"
                                    />
                                </div>

                                <div className="col-md-3">
                                    <h6
                                        style={{
                                            fontWeight: '600',
                                            fontSize: '16px',
                                        }}
                                    >
                                        New Scorecard
                                    </h6>
                                    <Dropdown
                                        name="newScoreCardId"
                                        filter
                                        value={newScoreCard}
                                        options={scoreCardsData?.data}
                                        onChange={(event) =>
                                            setNewScoreCard(
                                                event.target.value
                                            )
                                        }
                                        optionValue={'scorecard_id'}
                                        optionLabel={'scorecard_name'}
                                        placeholder="Select scorecard"
                                        className="custom-dropdown"
                                    // disabled={disableDisputeDetails}
                                    />
                                </div>

                                <div className="col-md-3 pe-0">
                                    <h6
                                        style={{
                                            fontWeight: '600',
                                            fontSize: '16px',
                                        }}
                                    >
                                        Inclusion
                                    </h6>
                                    <Dropdown
                                        name="scoreCardOverrideId"
                                        value={scoreCardOverride}
                                        options={
                                            scoreCardOverrideTypes?.data
                                        }
                                        onChange={(event) =>
                                            setScoreCardOverride(
                                                event.target.value
                                            )
                                        }
                                        optionValue={
                                            'scorecard_assign_override_type_id'
                                        }
                                        optionLabel={
                                            'scorecard_assign_override_type_name'
                                        }
                                        placeholder="Select Override"
                                        className="custom-dropdown"
                                    />
                                </div>
                            </div>
                            <div className='row mt-4'>
                                <div className="col-md-3">
                                    <h6
                                        style={{
                                            fontWeight: '600',
                                            fontSize: '16px',
                                        }}
                                    >
                                        Team Lead
                                    </h6>
                                    <Dropdown
                                        name="teamLead"
                                        value={supervisorNumber}
                                        filter
                                        onChange={SupervisorOnChange}
                                        options={listOfTls}
                                        optionValue={'id'}
                                        optionLabel={'name'}
                                        placeholder="Team Lead"
                                        className="custom-dropdown"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <h5 className='marginTop20'>Team Members</h5>
            <hr className="mt-2" />
            <div className="card-body p-0 align-middle text-center table">
                <DataTable
                    value={assignEmployees}
                    rows={5}

                    onSelectionChange={onSelectionChange}
                    selection={selectedAgnet}
                    paginator={assignEmployees?.length > 5}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    sortField="agent_name"
                    sortOrder={1}
                >
                    <Column key="check" selectionMode="multiple" headerStyle={{ visibility: 'hidden' }}
                        bodyStyle={{ minWidth: '1.5 rem' }} />
                    <Column
                        header="Oracle Id"
                        field="agent_number"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="agent_number"
                    />
                    <Column
                        header="Name"
                        field="agent_name"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="agent_name"
                    />
                    <Column
                        header="Team Lead"
                        field="supervisor_name"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="supervisor_name"
                    />
                </DataTable>
            </div>
            <div className="d-inline-block float-start float-md-end">
                <Button
                    type="button"
                    icon="pi pi-delete"
                    label="Apply"
                    disabled={!(selectedAgnet.length > 0)}
                    onClick={submitProjectAssignOverrideGroup}
                    className="btn-primary"
                />
            </div>
            <div className="card-body p-0 align-middle text-center table">
                <DataTable
                    value={assignOverridesm}
                    onSelectionChange={onSelectionChangeDelete}
                    header={overRideHeader}
                    selection={selectedAgentDelete}
                    className="groupAssignment"
                    rows={5}
                    filters={filters}
                    paginator={assignOverridesm?.length > 5}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                >
                    <Column key="check" selectionMode="multiple" headerStyle={{ maxWidth: '1.5 rem' }}
                        bodyStyle={{ minWidth: '1.5 rem' }} />
                    <Column
                        header="Oracle Id"
                        field="oracleId"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="oracleId"
                    />
                    <Column
                        header="Name"
                        field="name"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="name"
                    />
                    <Column
                        header="Previous Scorecard"
                        field="previousScorecard"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="previousScorecard"
                    />
                    <Column
                        header="New Scorecard"
                        field="newScorecard"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="newScorecard"
                    />
                    <Column
                        header="New Start Date"
                        field="startDate"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="startDate"
                        body={(date) => date.startDate ? DateTemplate(date?.startDate) : '--'}
                    />
                    <Column
                        header="End Date"
                        field="expirationDate"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="expirationDate"
                        body={(date) => date.expirationDate ? DateTemplate(date?.expirationDate) : '--'}
                    />
                    <Column
                        header="Inclusion"
                        field="inclusion"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="inclusion"
                    />
                </DataTable>

            </div>
            <div className="d-inline-block float-start float-md-end">
                <Button
                    type="button"
                    icon="pi pi-delete"
                    label="Delete"
                    disabled={!(selectedAgentDelete.length > 0)}
                    onClick={DeleteScorecardException}
                    className='btn-primary'
                />
            </div>
            <Dialog header="Response" visible={openDialog} style={{ width: '50vw' }} onHide={() => diloagHide()} footer={createFooterTemplate}>
                <div style={{maxHeight : '400px', overflowY: 'scroll'}} className='dialog-body'>
                <DataTable
                    value={statusData}
                    className="dataStatus"
                    rows={10}
                >
                    <Column
                        header="Employee Id"
                        field="employeeId"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="expirationDate"
                    />
                    <Column
                        header="Status"
                        field="status"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="status"
                        body={(rowData: any) => textColorCondition(rowData.status)}
                    />
                </DataTable>
                </div>

            </Dialog>
        </>
    )
}